const UserReportPage = () => {
  return (
    <div>
      <h1>User Report</h1>
    </div>
  );
};

export default UserReportPage;
